import { revertEmailChange as revertEmailChangeCallable } from '@griply/services';
import {
  AuthErrorKind,
  AuthFlow,
  AuthFlowError,
  EmailChangeRevertOutcome,
  RevertEmailChangeResponse,
} from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions, handleAuthError, reportAuthError } from './helpers';

const KIND_BY_OUTCOME = new Map<unknown, AuthErrorKind>([
  [EmailChangeRevertOutcome.InvalidLink, AuthErrorKind.InvalidLink],
  [EmailChangeRevertOutcome.EmailTaken, AuthErrorKind.EmailTaken],
  [EmailChangeRevertOutcome.WeakPassword, AuthErrorKind.WeakPassword],
]);

// Answers the address the account was restored to.
export const revertEmailChange = async (
  token: string,
  password: string,
): Promise<string> => {
  let result: RevertEmailChangeResponse;
  try {
    result = await revertEmailChangeCallable({
      functions: getFunctions(),
      httpsCallable,
      token,
      password,
    });
  } catch (error) {
    throw handleAuthError(error, AuthFlow.RevertEmailChange);
  }

  if (result.outcome === EmailChangeRevertOutcome.Reverted) {
    return result.email;
  }
  const kind = KIND_BY_OUTCOME.get(result.outcome);
  if (kind) {
    throw new AuthFlowError(kind);
  }
  const unknownAnswer = new Error(
    'users-revertEmailChange answered an unknown outcome',
  );
  reportAuthError(unknownAnswer, AuthFlow.RevertEmailChange, {
    outcome: result.outcome,
  });
  throw new AuthFlowError(AuthErrorKind.Unknown, { cause: unknownAnswer });
};
